import { createFileRoute } from "@tanstack/react-router";
import { redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: LandingPage,
  beforeLoad: async () => {
    // Check if we're on deployed.dev with code in the query params
    const urlParams = new URLSearchParams(window.location.search);
    const codeParam = urlParams.get("code");

    if (codeParam) {
      sessionStorage.setItem("REF_CODE_USER", codeParam as string);
      const url = new URL(window.location.href);
      url.searchParams.delete("code");
      window.history.replaceState({}, document.title, url.toString());
      window.location.href = "/dashboard";
      redirect({
        to: "/dashboard",
        throw: true,
      });
      return;
    }

    console.log("No REF code found in URL");
    redirect({
      to: "/dashboard",
      throw: true,
    });
    return {};
  },
});

function LandingPage() {
  return <></>;
}
